import { Button } from '../../../../ui/components/ui/button';
import FilterIcon from '../../../../ui/components/icons/filter-icon';
import { ArchiveFilter } from '../../constants/archive-filter.enum';

const ARCHIVE_FILTER_LABELS: Record<ArchiveFilter, string> = {
  [ArchiveFilter.ACTIVE]: 'Aktiv',
  [ArchiveFilter.ARCHIVED]: 'Archiviert',
  [ArchiveFilter.ALL]: 'Alle'
};

export interface ArchiveFilterButtonsProps {
  value: ArchiveFilter;
  onChange: (filter: ArchiveFilter) => void;
}

/** Filter buttons styled like the banner admin filter. */
const ArchiveFilterButtons = ({ value, onChange }: ArchiveFilterButtonsProps) => (
  <div className="flex gap-3">
    {Object.values(ArchiveFilter).map((filter) => {
      const isActive = filter === value;
      return (
        <Button
          key={filter}
          variant={isActive ? 'default' : 'outline'}
          className="flex gap-3 items-center rounded-2xl px-3 py-2 border text-sm"
          onClick={() => onChange(filter)}>
          <FilterIcon active={isActive} />
          {ARCHIVE_FILTER_LABELS[filter]}
        </Button>
      );
    })}
  </div>
);

export default ArchiveFilterButtons;
